import { PriceModuleLayoutTypeEnum } from '@inter-ikea-kompis/component-price-module';

enum ProductCardPriceLayoutTypeEnum {
	default = PriceModuleLayoutTypeEnum.default,
	subtle = PriceModuleLayoutTypeEnum.subtle,
	emphasized = PriceModuleLayoutTypeEnum.emphasized
}
export default ProductCardPriceLayoutTypeEnum;
